import React from 'react';
import { Grid, Segment, Form, Message, Button } from 'semantic-ui-react';
import axios from 'axios';
import _ from 'lodash';
import Zello from './Zello';

class Profile extends React.Component {
  constructor(props) {
    super(props);

    let state = {
      required: props.required,
      errors: {}
    };

    if (props.profile !== undefined) {
      state.name = props.profile.name;
      state.company = props.profile.company;
      state.website = props.profile.website;
      state.contactPhone = props.profile.phone;
      state.contactEmail = props.profile.email;
    } else {
      state.name = '';
      state.company = '';
      state.website = '';
      state.contactPhone = '';
      state.contactEmail = '';
    }

    this.state = state;
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      required: nextProps.required
    })
  }

  onValueChange = (value, e) => {
    let state = {
      errors: this.state.errors
    };
    state[value] = e.target.value;

    if (this.hasError(value)) {
      state.errors[value] = undefined;
    }
    this.setState(state);
  };

  hasError(value) {
    return this.state.errors[value] !== undefined;
  }

  getError(value) {
    if (this.hasError(value)) {
      return this.state.errors[value];
    }

    return '';
  }

  validate() {
    let errors = {};
    if (!this.state.name) {
      errors.name = 'Name must not be empty';
    } else if (this.state.name.indexOf(' ') < 1) {
      errors.name = 'Name is not valid';
    }

    if (!this.state.website) {
      errors.website = 'Website must not be empty';
    } else if (this.state.website.indexOf('.') < 1) {
      errors.website = 'Website is not valid';
    }

    if (!this.state.contactPhone) {
      errors.contactPhone = 'Contact phone must not be empty';
    }

    if (!this.state.contactEmail) {
      errors.contactEmail = 'Contact email must not be empty';
    } else if (this.state.contactEmail.indexOf('@') < 1) {
      errors.contactEmail = 'Contact email is not valid';
    }

    if (_.size(errors) > 0) {
      this.setState({
        errors
      });
      return false;
    }

    return true;
  }

  handleSubmit = (e) => {
    e.preventDefault();

    if (!this.validate()) {
      return;
    }

    const method = this.state.required ? 'post' : 'put';
    axios.request({
      url: Zello.getApiUrl('/users/me'),
      method: method,
      data: {
        name: this.state.name,
        company: this.state.company,
        website: this.state.website,
        contactPhone: this.state.contactPhone,
        contactEmail: this.state.contactEmail
      },
      withCredentials: true
    })
    .then((data) => {
      Zello.Profile = {
        name: this.state.name,
        company: this.state.company,
        website: this.state.website,
        phone: this.state.contactPhone,
        email: this.state.contactEmail
      };
      this.props.onComplete();
    })
    .catch((e) => {
      this.setState({
        errors: [{general: e}]
      });
    })
  };

  render() {
    return (
      <Grid columns='equal'>
        <Grid.Column>
        </Grid.Column>
        <Grid.Column width={8}>
          <Segment>
            {this.state.required && _.size(this.state.errors) === 0 && <Message warning>
              <p>Please complete your profile to access the development dashboard</p>
            </Message>}

            {_.size(this.state.errors) > 0 && <Message error>
              <p>There are problems with the form below, please correct them to continue</p>
            </Message>}

            <Form>
              <Form.Field>
                <label>Full Name*</label>
                <Form.Input placeholder='Your full name' value={this.state.name} error={this.hasError('name')} onChange={(e) => {this.onValueChange('name', e)}} />
                <span>{this.getError('name')}</span>
              </Form.Field>
              <Form.Field>
                <label>Company (optional)</label>
                <Form.Input placeholder="Company" value={this.state.company} error={this.hasError('company')} onChange={(e) => {this.onValueChange('company', e)}} />
                <span>{this.getError('company')}</span>
              </Form.Field>
              <Form.Field>
                <label>Website*</label>
                <Form.Input placeholder="Website URL" value={this.state.website} error={this.hasError('website')} onChange={(e) => {this.onValueChange('website', e)}} />
                <span>{this.getError('website')}</span>
              </Form.Field>
              <Form.Field>
                <label>Contact Phone*</label>
                <Form.Input placeholder="Phone" value={this.state.contactPhone} error={this.hasError('contactPhone')} onChange={(e) => {this.onValueChange('contactPhone', e)}} />
                <span>{this.getError('contactPhone')}</span>
              </Form.Field>
              <Form.Field>
                <label>Contact Email*</label>
                <Form.Input placeholder="Email" value={this.state.contactEmail} error={this.hasError('contactEmail')} onChange={(e) => {this.onValueChange('contactEmail', e)}} />
                <span>{this.getError('contactEmail')}</span>
              </Form.Field>

              <Grid>
                <Grid.Column textAlign="right">
                  {!this.state.required && <Button onClick={(e) => {e.preventDefault(); this.props.onComplete()}}>Back</Button>}
                  <Button onClick={this.handleSubmit} primary>
                    Submit
                  </Button>
                </Grid.Column>
              </Grid>
            </Form>
          </Segment>
        </Grid.Column>
        <Grid.Column>
        </Grid.Column>
      </Grid>
    );
  }
}

export default Profile;


// WEBPACK FOOTER //
// ./src/Profile.js